var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentBlockItemAdaptive3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 394,
    viewBox: "0 0 320 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 394,
    rx: 30,
    fill: "#0A021A",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 318,
    height: 392,
    rx: 29,
    stroke: "url(#paint0_linear_1510_26341)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1510_26341",
    x1: 212.043,
    y1: -63.7953,
    x2: 137.066,
    y2: 471.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9025FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654611,
    stopColor: "#403E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403E46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentBlockItemAdaptive3);
export default __webpack_public_path__ + "static/media/ContentBlockItemAdaptive3.5af9135efb034cd80974b3d2be77aa6e.svg";
export { ForwardRef as ReactComponent };